module.exports = __webpack_public_path__ + "img/inkling-min.f54ed429.png";